import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ourPropTypes from '../../../js/ourPropTypes';
import SelectWithAddEditControlView from '../SelectWithAddEditControlView';
import SqlServerInstanceAddForm from './SqlServerInstanceAddForm';
import { isAgentConnected, agentRequiresUpgrade } from '../../../js/projections/agents';

const sqlServerInstanceAddFormCreator = (onSuccess, onCancel) => 
    <SqlServerInstanceAddForm onSuccess={onSuccess} onCancel={onCancel} />;

const SqlServerInstanceSelection = React.createClass({
    propTypes: {
        labelText: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        onModeChanged: PropTypes.func,
        serverInstances: ourPropTypes.idNameArray.isRequired,
        value: PropTypes.string.isRequired,
        autoFocus: PropTypes.bool,
    },
    render: function () {
        const { labelText, serverInstances, value, autoFocus, onChange, onModeChanged } = this.props;

        return <SelectWithAddEditControlView 
            label={labelText}
            setupNewLabel="Add new instance..."
            items={serverInstances} 
            value={value} 
            autoFocus={autoFocus}
            onChange={onChange} 
            onModeChanged={onModeChanged} 
            addFormCreator={sqlServerInstanceAddFormCreator} />;
    }
});

const mapStateToProps = (state) => {
    return {
        serverInstances: Array.from(state.sqlServerInstances.value.values()).map(instance => {
            const baseName = instance.server + '\\' + instance.instance,
                connected = isAgentConnected(state, instance.agentId),
                requiresUpgrade = agentRequiresUpgrade(state, instance.agentId);

            return {
                id: instance.id,
                name: `${baseName}${!connected ? ' - agent disconnected' : (requiresUpgrade ? ' - agent requires upgrade' : '')}`,
                disabled: !connected || requiresUpgrade
            };
        })
    };
};

export default connect(mapStateToProps)(SqlServerInstanceSelection);



// WEBPACK FOOTER //
// ./src/components/common/SqlServerInstanceSelection/index.jsx